/**
 * Provides an empty function to use with callbacks
 */
export default function noop() {}

